import * as React from "react";
import { OverviewContainer, OverviewHighlightText } from "../../CommonComponents/CommonViews";
export const ProjectTasksHelp = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>
                The <b>tasks</b> section is where you can check on the status and history of the background tasks <b>associated with this project</b> that your Octopus Server is managing.
            </p>
        </OverviewHighlightText>
    </OverviewContainer>);
